import { PropsWithChildren } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface IProps {
  isOpened: boolean;
}
export const Collapse = (props: PropsWithChildren<IProps>) => {
  const { isOpened = false, children } = props;

  return (
    <AnimatePresence initial={false}>
      {isOpened && (
        <motion.div
          className="overflow-hidden"
          key="content"
          initial="collapsed"
          animate="open"
          exit="collapsed"
          variants={{
            open: { opacity: 1, height: 'auto' },
            collapsed: { opacity: 1, height: 0 },
          }}
          transition={{ duration: 0.35, ease: 'linear' }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
